const naturalPersonKeys = ['firstname', 'lastname'];
const legalPersonKeys = ['entityname'];

const enum PersonType {
  natural = 'N',
  legal = 'L',
}

const validKeys = (key: string, personType: string | PersonType): boolean =>
  personType === PersonType.natural
    ? naturalPersonKeys.some((k) => key.toLowerCase().includes(k))
    : legalPersonKeys.some((k) => key.toLowerCase().includes(k));

export const validationNames = (
  text: string,
  key?: string,
  personType: string | PersonType = PersonType.natural,
): string => {
  if (!key || !validKeys(key, personType)) return text;
  const regex =
    personType === PersonType.natural
      ? /^[a-zA-ZñÑ\s]+$/
      : /^[a-zA-ZñÑ\s0-9-]+$/;
  return text
    .split('')
    .filter((char) => regex.test(char))
    .join('')
    .toUpperCase();
};

export default validationNames;
